import React from 'react';
import {SearchField, DataGrid, RaymanUser, UserSize, FilterMenu, Text, SmartDateLabel, SmartTagText, IconMenu, Dialog} from 'components/core';
import {Grid, SvgIcon} from '@material-ui/core';
import {Timer} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {ProceduresCtx} from 'components/dataProviders/procedures';
import {TagsCtx} from 'components/dataProviders/tags';
import Singletons from 'controllers/Singletons';


const overrideStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)',
        '& .Mui-selected $icon':
        {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
        },
    },
    searchbox: {
        height: 40,
        width: 300
    },
    nameField: {
        display: "flex",
        flexDirection: "row",
        lineHeight: "30px",
        overflow: "hidden"
    },
    svg:
    {
        fill: "transparent"
    },
    icon: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: "50%",
        padding: 8,
        width: 40,
        height: 40,
        flexBasis: 40,
        textAlign: 'center',
        lineHeight: '24px',
        alignSelf: "center",
        marginRight: 5
    },
    twoRows: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden"
    },
    nameRow:
    {
        fontWeight: 500,
        marginLeft: 2,
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    timeRow: {
        lineHeight: "20px",
        height: 20,
        fontSize: "12px",
        display: "inline-flex",
        alignItems: "center",
        '& .MuiSvgIcon-root':
        {
            width: 14,
            height: 14,
            marginRight: 5
        }
    }
  }), {name: "ProceduresGrid"});

  
function secondsToMaskedTime(value)
{
    let min = Math.floor(value / 60);
    let hour = Math.floor(min / 60);
    min -= hour * 60;
    if(hour === 0)
    {
      if(min === 1) return "1 minuto";
      return min+" minutos";
    }
    else return hour.toString().padStart(2,"0")+"h "+min.toString().padStart(2,"0")+"m";
}

  function RowMenu({row, handleEdit})
  {
      const ctx = React.useContext(ProceduresCtx);
      const [open, setOpen] = React.useState(false);
      const [loading, setLoading] = React.useState(false);
  
      const handleClose = () => {
          setOpen(false);
      }
  
      const handleOpen = () => {
          setOpen(true);
      }
  
      const handleConfirm = () => {
          setLoading(true);
          ctx.funcs.delete(row.procedureID).then(() => {
              setLoading(false);
              setOpen(false);
          });
      }

      const handleClone = () => {
          setLoading(true);
          ctx.funcs.clone(row.procedureID).then(() => {
              setLoading(false);
          });
      }
  
      let items = [
        {
            label: "Editar",
            onClick: () => handleEdit()
        },
        {
            label: "Duplicar",
            onClick: () => handleClone()
        },
        {
            label: "Borrar",
            onClick: () => handleOpen(),
            danger: true
        } 
      ];
      return <>
      <Dialog title="Eliminar procedimiento" open={open} loading={loading} confirm="Eliminar" confirmColor="error" cancel="Cancelar" onConfirm={handleConfirm} onCancel={handleClose} onClose={handleClose}>
          ¿Está seguro? Una vez borrado no se podrá recuperar
        </Dialog>
      <IconMenu items={items} />
      </>
  }

  function NameField({row})
  {
      const classes = overrideStyle();
      return <div className={classes.nameField}>
                <div className={classes.icon}>
                    <SvgIcon className={classes.svg}>
                    <circle cx="12" cy="12" r="11.25" stroke="currentColor" strokeWidth="1.5" transform="matrix(-1 0 0 1 24 0)"/>
                    <circle cx="12" cy="12" r="1.714" fill="currentColor" transform="rotate(180 12 12)"/>
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5.657 11.52c0-3.503 2.84-6.343 6.343-6.343.746 0 1.462.129 2.127.366m3.656 3.368c.36.796.56 1.68.56 2.609M12.938 10.817L17.518 5.438"/>
                    </SvgIcon>
                </div>
                <div className={classes.twoRows}>
                    <Text className={classes.nameRow}>{row.name}</Text>
                    <div className={classes.timeRow}><Timer />   {secondsToMaskedTime(row.executionTime)}</div>
                </div>
            </div>
  }

const columns = {
    name: { 
        field: 'name',
        headerName: 'Nombre del procedimiento',
        flex: 1,
        renderCell: (params) => {
            return <NameField row={params.row} />
        }
    },
    lastModificationDatetime: {
        field: 'lastModificationDatetime',
        headerName: 'Ult. Modificación',
        width: 170,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            </>;
        }
    },
    lastModificationUser: {
        field: 'lastModificationUser',
        headerName: 'Modificado por',
        flex: 0.5,
        renderCell: (params) => {
            return <RaymanUser userID={params.value} size={UserSize.size32} />
        }
    },
    tags: {
        field: 'tags',
        headerName: 'Etiquetas',
        flex: 0.5,
        renderCell: (params) => {
            return <SmartTagText tagIDs={params.value} />
        }
    }
}

const collapsedColumns = [columns.name, columns.tags];
const extendedColumns = [columns.name, columns.lastModificationDatetime, columns.lastModificationUser, columns.tags];


export default function ProceduresList({onRowSelected = () => {}, collapsed = false, handleEdit, dataset="open"})
{
    const classes = overrideStyle();
    const procsCtx = React.useContext(ProceduresCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const [data, setData] = React.useState(procsCtx.data.array);
    const [filters, setFilters] = React.useState({text: '', tags: []});
    const [gridColumns, setGridColumns] = React.useState([]);
    const [filterTags, setFilterTags] = React.useState([]);

    let searchTimeout = 0;

    const menuColumn = React.useMemo(() => ({
        field: 'menu',
        headerName: ' ',
        width: 40,
        align: 'center',
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return <RowMenu row={params.row} handleEdit={() => handleEdit(params.row.procedureID)}/>
        }
    }),[handleEdit]);


    React.useEffect(function filterData(){
        
        let tmpData = [...procsCtx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            if(filters.tags.length > 0) result &= value.tags.some(r => filters.tags.includes(r));
            return result;
        });

        setData(tmpData);
    }, [procsCtx, dataset, filters]);

    React.useEffect(function initializeFilterTags() {
        let tags = [];
        tagsCtx.data.array.forEach((item) => tags.push({value: item.tagID, text: item.name}));

        setFilterTags(tags);
    }, [tagsCtx]);

    React.useEffect(function handleColumns(){

        let gridCols = collapsed ? [...collapsedColumns] : [...extendedColumns];
        if(Singletons.userProfiles.expert || Singletons.userProfiles.admin) gridCols.push(menuColumn);
        if(dataset === "closed") gridCols.splice(gridCols.length - 2, 1, columns.closed);
        setGridColumns(gridCols);
    }, [dataset, collapsed, menuColumn]);

    const handleSelectRow = (row) =>
    {
        onRowSelected(row);
    }

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    const handleTagsChange = React.useCallback((tags) => {
        let tmpFilters = {...filters};
        tmpFilters.tags = tags;
        
        if(tmpFilters.tags.join(",") !== filters.tags.join(","))
        {
            setFilters(tmpFilters);
        }
        
    }, [filters]);

    return <>
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                    <Grid item><Text>Filtros:</Text> </Grid>
                    <Grid item><FilterMenu label={"Etiquetas"} items={filterTags} onChange={handleTagsChange}/></Grid>
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        onRowSelected = {(row) => handleSelectRow(row.data)}
        loading={procsCtx.loading}
        density="comfortable"
        className={classes.datagrid}
        />
    </>
}